import React from "react";
import { FormHelperText, InputLabel, NativeSelect } from "@material-ui/core";

export const CustomNativeSelect = ({
  name,
  placeholder = "Выберите...",
  label,
  index,
  handleChange,
  value,
  error = false,
  errMessage,
  required = false,
  id = "",
  options,
  optionValue,
  optionKey,
  optionDisplay,
  hidden = true,
  disabled = false
}) => {
  return (
    <>
      <InputLabel
        variant="standard"
        htmlFor="uncontrolled-native"
        error={error}
        required={required}
      >
        {label}
      </InputLabel>
      <NativeSelect
        disabled={disabled}
        fullWidth
        id={id}
        error={error}
        value={value || ""}
        onChange={e => handleChange(e, index)}
        inputProps={{
          name: name,
          id: "uncontrolled-native"
        }}
      >
        <option value={""} hidden={hidden}>
          {placeholder}
        </option>
        {options?.map(el => (
          <option value={el[optionValue]} key={el[optionKey]}>
            {el[optionDisplay]}
          </option>
        ))}
      </NativeSelect>
      {error ? (
        <FormHelperText error={error}>{errMessage}</FormHelperText>
      ) : null}
    </>
  );
};
